<template>
    <div
    >
      <div v-if="ready">
        <vs-divider>Instituciones por provincia</vs-divider>
        <p style="display: none;">{{ series }}</p>
        <div id="chart" style="width: 100%;">
          <apexchart
            type="bar"
            height="430"
            :options="options"
            :series="[series[0]]"
          ></apexchart>
        </div>
      </div>
      
    </div>
  </template>
  <script>
  import chart from "vue-apexcharts";
  // import moment from 'moment'
  export default{
    components: { apexchart: chart },
    data(){
        return{
          ready:false,
          arregloReporteCiudad:[],
          series: [{
              name: 'Reporte de ciudades',
              data: []
          }],
          options: {
            chart: {
              type: 'bar',
              height: 430,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                dataLabels: {
                  position: 'top',
                },
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val + ' instituciones.';
              },
              offsetX: -6,
              style: {
                fontSize: '12px',
                colors: ['#fff']
              }
            },
            stroke: {
              show: true,
              width: 1,
              colors: ['#fff']
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            xaxis: {
              categories: [],
              labels: {
                useHTML: true,
              },
            },
            yaxis: {
              labels: {
                useHTML: true,
              },
            },
          },
        }
    },
    created(){},
    mounted(){
      let me = this
      me.reporteInstitucionesXCiudad()
    },
    methods:{
      reporteInstitucionesXCiudad(){
        let me = this;
        me.$vs.loading();
        this.$http.get(this.$server_url+'institucion?reporteInstitucionesXCiudad=yes')
        .then(function (res) {
            me.arregloReporteCiudad = res.data
            if(me.arregloReporteCiudad.length > 0){
              setTimeout(() => {
                me.renderReporteCiudad(me.arregloReporteCiudad)
              }, 1000)
            }
            me.$vs.loading.close()
        })
        .catch(function (error) {
            console.log(error + ' error');
            me.$vs.loading.close()
        })
      },
      renderReporteCiudad(datos){
        let me = this
        var valores = []
        datos.map((p,key) =>{
          me.options.xaxis.categories[key] = p.provincia
          valores.push(p.contador)
        })
        this.series[0].data = valores;
        me.ready = true
      }
    }
  }
  </script>
  